class UseRecaptchaService {
  private static readonly siteKey: string =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

  private static readonly checkboxSiteKey: string =
    process.env.REACT_APP_RECAPTCHA_CHECKBOX_SITE_KEY || "";

  static isEnabled(): boolean {
    return Boolean(this.siteKey);
  }

  static getCheckboxSiteKey(): string {
    return this.checkboxSiteKey;
  }
}

export default UseRecaptchaService;
